export const palette = {
  black: '#000000',
  white: '#FFFFFF',

  neutral: {
    900: '#000000',
    800: '#0A0A0A',
    700: '#1A1A1A',
    650: '#333333',
    600: '#2A2A2A',
    550: '#444444',
    500: '#3A3A3A',
    450: '#666666',
    400: '#666666',
    350: '#888888',
    300: '#999999',
    200: '#CCCCCC',
    100: '#E5E5E5',
    50: '#F5F5F5',
  },

  brand: {
    primary: '#A855F7',
    primaryDark: '#7C3AED',
    primaryLight: '#C084FC',
  },

  semantic: {
    success: '#22C55E',
    successAlt: '#4CAF50',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
  },

  accent: {
    info: '#0A84FF',
    gold: '#FFD700',
    destructive: '#FF3B30',
  },
} as const;

export const overlay = {
  scrim: 'rgba(0, 0, 0, 0.5)',
  scrimStrong: 'rgba(0, 0, 0, 0.85)',
  scrimMedium: 'rgba(0, 0, 0, 0.75)',
  scrimLight: 'rgba(0, 0, 0, 0.3)',
  backdrop: 'rgba(0, 0, 0, 0.6)',
  whiteScrim: 'rgba(255, 255, 255, 0.1)',
} as const;

export type Palette = typeof palette;
export type Overlay = typeof overlay;
